import * as React from 'react';
import * as moment from 'moment';
import * as $ from 'jquery';
import * as classNames from 'classnames';
import Loader from '../../shared/loader';
import { pick, isEmpty } from 'lodash';
import Categories from '../../shared/categories';
import Description from './description.autocomplete';
import { fetchDescriptions } from '../../actions/expenses';

export default class AddExpense extends React.Component<
  { accounts; expenses; fetchAccounts; fetchExpense; updateExpense; history },
  {
    _id: string;
    descriptionLabel;
    date: string;
    category: string;
    description: string;
    account: string;
    toAccount: string;
    value: number;
    type: string;
    loading: boolean;
    error: boolean;
    accountSet: boolean;
    toAccountSet: boolean;
    categorySet: boolean;
    typeSet: boolean;
    valueSet: boolean;
  }
> {
  constructor(props) {
    super(props);
    const { search, state } = props.location;
    let expense = {} as any;
    if (search) {
      const _id = new URLSearchParams(search).get('_id');
      props.fetchExpense(_id);
      expense = (props.expenses && props.expenses[_id]) || {};
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addIcon = this.addIcon.bind(this);

    this.state = {
      ...this.state,
      _id: expense._id,
      date: moment(expense.date || new Date()).format('YYYY-MM-DD'),
      category: expense.category || '',
      description: expense.description || '',
      value: expense.value,
      account:
        expense.account ||
        (expense.account === undefined &&
          Object.keys(props.accounts).sort((a, b) => props.accounts[b].preference - props.accounts[a].preference)[0]),
      toAccount:
        expense.toAccount ||
        Object.keys(props.accounts).sort((a, b) => props.accounts[b].preference - props.accounts[a].preference)[0],
      type: expense.type || 'EXPENSE',
      accountSet: !!expense.value,
      toAccountSet: !!expense.value,
      categorySet: !!expense.category,
      typeSet: !!expense.type,
      valueSet: !!expense.value,
      ...state
    };
  }

  componentDidUpdate() {
    $('select').material_select();
  }

  initialize(nextProps) {
    const { search, state } = nextProps.location;
    let expense: any = {};
    if (search) {
      const _id = new URLSearchParams(search).get('_id');
      expense = (nextProps.expenses && nextProps.expenses[_id]) || {};
    }
    this.setState({
      ...this.state,
      _id: expense._id,
      date: moment(expense.date || new Date()).format('YYYY-MM-DD'),
      category: expense.category || '',
      description: expense.description || '',
      value: expense.value,
      account:
        expense.account ||
        (expense.account === undefined &&
          Object.keys(nextProps.accounts).sort(
            (a, b) => nextProps.accounts[b].preference - nextProps.accounts[a].preference
          )[0]),
      toAccount:
        expense.toAccount ||
        Object.keys(nextProps.accounts).sort(
          (a, b) => nextProps.accounts[b].preference - nextProps.accounts[a].preference
        )[0],
      type: expense.type || 'EXPENSE',
      ...state
    });
  }

  componentWillReceiveProps(nextProps) {
    this.initialize(nextProps);
  }

  componentDidMount() {
    $('select').material_select();
    $(this.refs.mySelectBox).on('change', this.handleChange('type'));
  }

  handleChange(el) {
    return event => {
      this.setState({ [el]: event.target.value, [`${el}Set`]: true } as any);
    };
  }

  selectAccount() {
    const { accounts } = this.props;
    const { type } = this.state;
    return Object.keys(accounts).map(a => (
      <option disabled={a === this.state.toAccount && this.state.type === 'TRANSFER'} value={a}>
        {accounts[a].name}
      </option>
    ));
  }

  selectToAccount() {
    const { accounts } = this.props;
    return Object.keys(accounts).map(a => (
      <option disabled={a === this.state.account && this.state.type === 'TRANSFER'} value={a}>
        {accounts[a].name}
      </option>
    ));
  }

  async handleSubmit(e) {
    e.preventDefault();
    if (isEmpty(this.state.category)) {
      return this.setState({ error: true });
    }
    this.setState({ loading: true });
    const model = pick(this.state, ['_id', 'date', 'category', 'description', 'value', 'account', 'type']) as any;
    if (model.type === 'TRANSFER' || model.type === 'INCOME') {
      model.toAccount = this.state.toAccount;
    }
    await this.props.updateExpense(model);
    if (this.props.history.length > 2) {
      this.props.history.goBack();
    } else {
      this.props.history.push('/dashboard');
    }
  }

  addIcon(iconName, category, title) {
    const className = classNames('inline-block', {
      ['indigo lighten-4']: this.state.category === category
    });
    const iconClassName = classNames('material-icons', 'blue-text', 'medium');
    return (
      <div className={className}>
        <a
          href="#"
          onClick={event => {
            event.preventDefault();
            if (category === 'withdrawal') {
              this.setState({
                toAccountSet: true,
                toAccount: Object.keys(this.props.accounts).find(a => this.props.accounts[a].isCash),
                account: Object.keys(this.props.accounts)
                  .filter(a => !this.props.accounts[a].isCash)
                  .sort((a, b) => this.props.accounts[b].preference - this.props.accounts[a].preference)[0]
              });
            } else if (category === 'deposit') {
              this.setState({
                accountSet: true,
                account: Object.keys(this.props.accounts).find(a => this.props.accounts[a].isCash),
                toAccount: Object.keys(this.props.accounts)
                  .filter(a => !this.props.accounts[a].isCash)
                  .sort((a, b) => this.props.accounts[b].preference - this.props.accounts[a].preference)[0]
              });
            } else if (category === 'transfer') {
              let accounts = Object.keys(this.props.accounts)
                .filter(a => !this.props.accounts[a].isCash)
                .sort((a, b) => this.props.accounts[b].preference - this.props.accounts[a].preference);
              this.setState({
                accountSet: true,
                account: accounts[0],
                toAccount: accounts[1]
              });
            }
            this.setState({ error: false, category, categorySet: true });
          }}
          title={title}
        >
          <i className={iconClassName}>{iconName}</i>
          <label>{category}</label>
        </a>
      </div>
    );
  }

  render() {
    const categories = Categories;
    if (this.state.loading) {
      return <Loader />;
    }
    return (
      <div className="addExpense">
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className=" col s2" />
            <div className="input-field col s8">
              <label
                className={classNames({ active: this.state.descriptionLabel || !!this.state.description })}
                htmlFor="description"
              >
                Description
              </label>
              <Description
                id="description"
                value={this.state.description}
                fetchItems={fetchDescriptions}
                onChange={this.handleChange('description')}
                label="description"
                items={Object.keys(this.props.expenses).map(key => this.props.expenses[key])}
                onFocus={() => this.setState({ descriptionLabel: true })}
                onBlur={() => this.setState({ descriptionLabel: false })}
                onSelect={({ value, type, account, category, toAccount }) => {
                  this.setState({
                    value: this.state.valueSet ? this.state.value : value,
                    type: this.state.typeSet ? this.state.type : type,
                    account: this.state.accountSet ? this.state.account : account,
                    toAccount: this.state.toAccountSet ? this.state.toAccount : toAccount,
                    category: this.state.categorySet ? this.state.category : category
                  });
                }}
              />
            </div>
            <div className=" col s1" />
          </div>

          <div className="row">
            <div className="select-field col s2 right-align customSelect">
              <select ref="mySelectBox" value={this.state.type} onChange={this.handleChange('type')}>
                <option value="EXPENSE">-</option>
                <option value="INCOME">+</option>
                <option value="TRANSFER">⇄</option>
              </select>
            </div>
            <div className="input-field col s8">
              <label className={classNames({ active: !!this.state.value })} htmlFor="value">
                Amount
              </label>
              <input
                id="value"
                type="number"
                required
                className="validate"
                value={this.state.value}
                onChange={this.handleChange('value')}
                step="any"
              />
            </div>
            <div className=" col s2" />
          </div>

          <div className="category">
            <div className="row">
              <div className="col s0 m2" />
              <label>Category</label>
              {this.state.error && (
                <div>
                  <br />
                  <div className="col s2" />
                  <div className="red-text text-lighten-2">Choose Category</div>
                </div>
              )}
            </div>

            {this.state.type === 'EXPENSE' && (
              <div>
                <div className="row icons">
                  <div className="col s0 m2" />
                  <span>Weekly</span>
                  {Object.keys(categories)
                    .filter(i => categories[i].type === 'weekly')
                    .map(i => this.addIcon(categories[i].icon, i, categories[i].title))}
                </div>

                <div className="row icons">
                  <div className="col s0 m2" />
                  <span>Monthly</span>
                  {Object.keys(categories)
                    .filter(i => categories[i].type === 'monthly')
                    .map(i => this.addIcon(categories[i].icon, i, categories[i].title))}
                </div>

                <div className="row icons">
                  <div className="col s0 m2" />
                  <span>Yearly</span>
                  {Object.keys(categories)
                    .filter(i => categories[i].type === 'yearly')
                    .map(i => this.addIcon(categories[i].icon, i, categories[i].title))}
                </div>
              </div>
            )}

            {this.state.type === 'INCOME' && (
              <div>
                <div className="row icons">
                  <div className="col s0 m2" />
                  <span>Monthly</span>
                  {Object.keys(categories)
                    .filter(i => categories[i].type.startsWith('income_monthly'))
                    .map(i => this.addIcon(categories[i].icon, i, categories[i].title))}
                </div>

                <div className="row icons">
                  <div className="col s0 m2" />
                  <span>Yearly</span>
                  {Object.keys(categories)
                    .filter(i => categories[i].type.startsWith('income_yearly'))
                    .map(i => this.addIcon(categories[i].icon, i, categories[i].title))}
                </div>
              </div>
            )}

            {this.state.type === 'TRANSFER' && (
              <div className="row icons">
                <div className="col s0 m2" />
                <span title="Won't count as expense or income">Transfer</span>
                {Object.keys(categories)
                  .filter(i => categories[i].type === 'transfer')
                  .map(i => this.addIcon(categories[i].icon, i, categories[i].title))}
              </div>
            )}
          </div>

          <div className="row" />
          <div className="row" />

          <div className="row date_input">
            <div className=" col s0 m1" />
            <div className="input-field col s6 m4">
              <input
                id="date"
                type="date"
                className="validate center-align indigo lighten-5"
                value={this.state.date}
                onChange={this.handleChange('date')}
                required
              />
            </div>

            {(this.state.type == 'TRANSFER' || this.state.type == 'EXPENSE') && (
              <div className="input-field col s4">
                <select
                  disabled={this.state.category === 'deposit'}
                  className="browser-default indigo lighten-5"
                  value={this.state.account}
                  onChange={this.handleChange('account')}
                >
                  {this.selectAccount()}
                </select>
              </div>
            )}

            {(this.state.type == 'TRANSFER' || this.state.type == 'INCOME') && [
              <div className="input-field col s4">
                <select
                  id="toAccount"
                  disabled={this.state.category === 'withdrawal'}
                  className="browser-default indigo lighten-5"
                  value={this.state.toAccount}
                  onChange={this.handleChange('toAccount')}
                >
                  {this.selectToAccount()}
                </select>
              </div>
            ]}
          </div>

          <div className="fixed-action-btn">
            <div className="center-align">
              <button type="submit" className="btn-floating btn-large waves-effect waves-light light-blue darken-3">
                <i className="material-icons">done</i>
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/expenses/update-expense/component.tsx